import { ActivatedRoute } from '@angular/router';
import {
  ModifierPrompt,
  ModifierPromptOption,
  PopularItem,
  ProductionAreaOverride,
  RealtimeReportParams,
  SalesByDinerTypeResponse,
  SalesByMenuCategoryResponse,
  SalesByPaymentTypeResponse,
  SalesByPosOperatorsResponse,
  TotalsResponse
} from 'src/app/models/pos-manager.model';

export class GetSharedObjects {
  static readonly type = '[POS Manager] Get Shared Objects';
}
export class GetModifierPrompts {
  static readonly type = '[POS Manager] Get Modifier Prompts';
}

export class PosManagerLocalizedDataRefreshed {
  static readonly type = '[POS Manager] Localized Data Refreshed';
}

export class GetModifierPromptsSuccess {
  static readonly type = '[POS Manager] Get Modifier Prompts Success';
  constructor(public modifierPrompts: ModifierPrompt[]) {}
}

export class GetEmbeddedDashboardUrl {
  static readonly type = '[POS Manager] Get Embedded Dashboard Url';
}

export class SelectModifierPrompt {
  static readonly type = '[POS Manager] Select Modifier Prompt';
  constructor(public id: number) {}
}

export class ClearSelectedModifierPrompt {
  static readonly type = '[POS Manager] Clear Selected Modifier Prompt';
  constructor() {}
}

export class SelectModifierPromptError {
  static readonly type = '[POS Manager] Select Modifier Prompt Error';
}

export class CreateModifierPrompt {
  static readonly type = '[POS Manager] Create Modifier Prompt';
  constructor(
    public name: string,
    public modifierPromptOptions: ModifierPromptOption[]
  ) {}
}

export class CreateModifierPromptSuccess {
  static readonly type = '[POS Manager] Create Modifier Prompt Success';
}

export class UpdateModifierPrompt {
  static readonly type = '[POS Manager] Update Modifier Prompt';
  constructor(
    public id: number,
    public name: string,
    public modifierPromptOptions: ModifierPromptOption[]
  ) {}
}

export class UpdateModifierPromptSuccess {
  static readonly type = '[POS Manager] Update Modifier Prompt Success';
}

export class DeleteModifierPrompt {
  static readonly type = '[POS Manager] Delete Modifier Prompt';
  constructor(public id: number) {}
}

export class GetProducts {
  static readonly type = '[POS Manager] Get Products';
}

export class PosManagerBackToPos {
  static readonly type = '[POS Manager] POS Manager Back To POS';
  constructor(public readonly route: ActivatedRoute) {}
}

export class GetProductionAreaOverrides {
  static readonly type = '[POS Manager] Get Production Area Overrides';

  constructor(public posLocationId: number) {}
}

export class CreateOrUpdateProductionAreaOverride {
  static readonly type =
    '[POS Manager] Create or Update Production Area Override';
  constructor(public payload: ProductionAreaOverride) {}
}

export class CreateOrUpdateProductionAreaOverrideSuccess {
  static readonly type =
    '[POS Manager] Create or Update Production Area Override Success';
  constructor(public response: ProductionAreaOverride) {}
}

export class DeleteProductionAreaOverride {
  static readonly type = '[POS Manager] Delete Production Area Override';
  constructor(public id: number) {}
}

export class DeleteProductionAreaOverrideSuccess {
  static readonly type =
    '[POS Manager] Delete Production Area Override Success';
  constructor(public id: number) {}
}

export class GetRealtimeInfo {
  static readonly type = '[POS Manager] Get Realtime Info';
  constructor(public params: RealtimeReportParams) {}
}

export class GetRealtimeTotalsSuccess {
  static readonly type = '[POS Manager] Get Realtime Totals Success';
  constructor(public response: TotalsResponse) {}
}

export class GetRealtimeSalesByPaymentTypeSuccess {
  static readonly type =
    '[POS Manager] Get Realtime Sales By Payment Type Success';
  constructor(public response: SalesByPaymentTypeResponse) {}
}

export class GetRealtimeSalesByDinerTypeSuccess {
  static readonly type =
    '[POS Manager] Get Realtime Sales By Diner Type Success';
  constructor(public response: SalesByDinerTypeResponse) {}
}

export class GetRealtimeMostPopularItemsSuccess {
  static readonly type =
    '[POS Manager] Get Realtime Most Popular Items Success';
  constructor(public response: PopularItem[]) {}
}

export class GetRealtimeSalesByMenuCategory {
  static readonly type = '[POS Manager] Get Realtime Sales By Menu Category';
  constructor(public params: RealtimeReportParams) {}
}

export class GetRealtimeSalesByMenuCategorySuccess {
  static readonly type =
    '[POS Manager] Get Realtime Sales By Menu Category Success';
  constructor(public response: SalesByMenuCategoryResponse) {}
}

export class GetRealtimeSalesByPosOperators {
  static readonly type = '[POS Manager] Get Realtime Sales By POS Operators';
  constructor(public params: RealtimeReportParams) {}
}

export class GetRealtimeSalesByPosOperatorsSuccess {
  static readonly type =
    '[POS Manager] Get Realtime Sales By POS Operators Success';
  constructor(public response: SalesByPosOperatorsResponse) {}
}
